
import { Tooltip, PopoverPosition, Dialog } from "construct-ui";
import ViewBase from "../../view-base.view";
import fixtureModel from '../../../models/planogram/fixture.model';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import PhotoInputComponent from "../../../components/photo/photo-input.component";
import codeMasterModel from "../../../models/common/code-master.model";
import loginModel from "../../../models/login.model";
import FixtureUploadResult from "./fixture-upload-result.dialog"
import { codeMasterType } from "../../../config/constants";

export default function PopupAddView() {
  ViewBase.call(this);

  let onClose = (e) => { };
  let onSaveComplete = (e) => { };
  let planogramDivGroups = [];
  let planogramTypeList = [];
  let isResultDialogOpen = false;
  let uploadedResult = [];

  const inputDataModel = {
    divGroup: '',
    planogramType: '',
    status: 1
  };

  let userUploadedFiles = [];

  const getPlanogramDivGroups = () => {
    codeMasterModel.getCodemasterCategoryData(loginModel.credentials.country, codeMasterType.planogramDivGroup)
      .then(result => {
        planogramDivGroups = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getPlanogramTypes = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.planogramType })
      .then(result => {
        planogramTypeList = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const handleSave = (e) => {
    if (!this.validateForm(e, "#uploadFixture")) {
      return false;
    } else {
      const params = structuredClone(inputDataModel);

      let filesFormData = new FormData();
      userUploadedFiles.forEach((file) => {
        filesFormData.append("file", file);
      });

      for (const p in params) {
        filesFormData.append(p, params[p]);
      }

      const paramsObj = { method: 'POST', body: filesFormData };
      const abortable = true;
      fixtureModel.saveFixture(paramsObj, abortable).then((result) => {
        isResultDialogOpen = true;
        uploadedResult = result
      }).catch((error) => {
        this.handleError(error);
      })
    }
  }

  const handleCancel = (e) => {
    onClose(e);
  }
  const closeResultModal = () => {
    isResultDialogOpen = false;
    onSaveComplete();
  }
  return {
    oninit: (vnode) => {
      getPlanogramDivGroups();
      getPlanogramTypes();

      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
      if (vnode.attrs.onSave) {
        onSave = vnode.attrs.onSave;
      }

    },
    view: (vnode) => {
      return [
        m("form#uploadFixture.card-body.needs-validation[novalidate]", { onsubmit: handleSave },
          m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='divGroupisionGroup']",
              this.getText("LT00000246", "Division Group")
            ),
            m(SingleSelectComponent, {
              id: "divGroupisionGroup",
              allowEmpty: false,
              items: planogramDivGroups,
              selectedItem: planogramDivGroups.find(e => e.code === inputDataModel.divGroup),
              onSelect: (s) => {
                inputDataModel.divGroup = s.code;
              },
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),

          m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='planogramType']",
              this.getText('LT00001198', 'Image Type')
            ),
            m(SingleSelectComponent, {
              id: "planogramType",
              items: planogramTypeList,
              allowEmpty: false,
              selectedItem: planogramTypeList.find(e => e.code === inputDataModel.planogramType),
              onSelect: (s) => {
                inputDataModel.planogramType = s.code;
              },
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m('.mt-2.position-relative',
            m("label.form-label.mandatory[for='photo']", this.getText("LT00000047", "Attachments"), m(Tooltip, {
              content: this.getText("EM00000826", "Please note that the name of the image you upload must be unique."),
              hoverOpenDelay: 250,
              openOnTriggerFocus: true,
              position: PopoverPosition.RIGHT,
              trigger: m('i.bi.bi-info-circle.cursor-pointer.ps-1.me-0', { style: { 'color': '#FF9800' } })
            })
            ),
            m(PhotoInputComponent, {
              id: "001",
              photoCountLimit: 10,
              onInput: (value) => {
                userUploadedFiles = value;
              },
              required: true
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m('.col-md-12.gap-2.mt-4.d-flex.justify-content-end',
            m('button.btn.btn-primary[type="submit"].px-4.gap-3', this.getText('LT00000022', "Save")),
            m(
              "button.btn.btn-white[type='button']", { onclick: handleCancel },
              this.getText("LT00000021", "Close")
            )
          )
        ),
        isResultDialogOpen &&
        m(Dialog, {
          isOpen: isResultDialogOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeResultModal,
          title: this.getText("LT00000947", "Result"),
          content: m(FixtureUploadResult, {
            uploadedResult: uploadedResult,
            onClose: closeResultModal
          }),
          "class": "cui-dialog",
        }),
        this.getBaseViews()
      ];
    }
  }
}
